module.exports = __webpack_public_path__ + "assets/phone.8fde6c6c.svg";